import { Input, InputProps } from 'antd';
import { Field } from 'formik';
import React, { FC } from 'react';

import { StyledError, StyledFormikInputFieldWithLabel, StyledLabel, fieldError } from './styles';

interface FormikInputFieldWithLabelProps extends Omit<InputProps, 'defaultValue'> {
  label: string;
  errors?: string;
  touched?: boolean;
  defaultValue: boolean;
}

export const FormikCheckboxWithLabel: FC<FormikInputFieldWithLabelProps> = ({
  label,
  defaultValue = false,
  onChange,
  errors,
  touched,
  ...restProps
}) => {
  return (
    <>
      <StyledFormikInputFieldWithLabel>
        <StyledLabel>{label}</StyledLabel>
        <Field
          style={errors && touched ? fieldError : {}}
          type="checkbox"
          // as={Input}
          defaultValue={defaultValue}
          onChange={onChange}
          {...restProps}
        />
      </StyledFormikInputFieldWithLabel>
      {errors && touched ? <StyledError>{errors}</StyledError> : null}
    </>
  );
};
